<template>
  <div class="content">
    <div class="header" v-if="$route.name != 'ThePrintlca'">
      <div class="title">
        <router-link to="/">三合盛-双碳管理平台</router-link>
      </div>
      <div class="navgate">
        <div>
          <router-link active-class="bgImage" to="/EconomicIndicators"
            >碳核算</router-link
          >
        </div>
        <div>
          <router-link active-class="bgImage" to="/EnergyCReduction"
            >新能源减碳</router-link
          >
        </div>
        <div>
          <router-link active-class="bgImage" to="/steelcarbonfootprint"
            >钢碳足迹</router-link
          >
        </div>
        <div>
          <router-link active-class="bgImage" to="/aluminumCarbonFootprint"
            >铝碳足迹</router-link
          >
        </div>
        <!-- <div>
          <router-link active-class="bgImage" to="/CarbonTradingInfo"
            >碳交易咨讯</router-link
          >
        </div> -->
        <div>
          <router-link active-class="bgImage" to="/Pre-admissionDeclaration"
            >三合盛AI</router-link
          >
        </div>
        <div>
          <router-link active-class="bgImage" to="/CarbonCalcu"
            ><span style="font-size: 0.8em">CO</span> 2计算器</router-link
          >
        </div>
        <div>
          <router-link active-class="bgImage" to="/EnergyCarbonManagement"
            >能碳管理</router-link
          >
        </div>
      </div>
      <div class="righttopic">
        <span class="times">{{ time }}</span>
        <div class="other">
          <span>{{ YMD }} </span>
          <span style="color: #fff; margin-left: 0.3125rem">{{
            whichday
          }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="head" @click="eventChange">
      <router-link active-class="bgImage" exact to="/"
        >智慧生态园区</router-link
      >
      <router-link active-class="bgImage" to="/AlertManagement"
        >告警管理</router-link
      >
      <router-link active-class="bgImage" to="/RealTimeMonitoring"
        >实时监控</router-link
      >
      <router-link active-class="bgImage" to="/EconomicIndicators"
        >报表管理</router-link
      >
      <router-link
        active-class="bgImage"
        to="/EconomyAndInformationTechnologyBureau"
        >经济指标</router-link
      >
      <router-link active-class="bgImage" to="/StatementManagement"
        >生态指标</router-link
      >
      <router-link active-class="bgImage" to="/EcologicalIndex"
        >经信局</router-link
      >
      <router-link active-class="bgImage" to="/EcologyAndEnvironment"
        >生态环境局</router-link
      >
      <router-link active-class="bgImage" to="/Pre-admissionDeclaration"
        >三合盛AI助手</router-link
      >
    </div> -->
    <keep-alive
      :include="['Pre-admissionDeclaration', 'EnergyCReduction', 'RobotModule']"
    >
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
export default {
  data() {
    return {
      time: "",
      whichday: "",
      YMD: "",
    };
  },
  methods: {
    currentTime() {
      setInterval(this.getTime, 800);
    },
    myFriday(value) {
      // console.log(value, "value");
      let key = value % 7;

      switch (key) {
        case 0:
          return "星期日";
          break;
        case 1:
          return "星期一";
          break;
        case 2:
          return "星期二";
          break;
        case 3:
          return "星期三";
          break;
        case 4:
          return "星期四";
          break;
        case 5:
          return "星期五";
          break;
        case 6:
          return "星期六";
          break;
        default:
          break;
      }
    },
    getTime() {
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      this.time = hh + ":" + mf + ":" + ss;
      if (!this.YMD) {
        this.YMD = mm + "/" + dd + "/ " + yy;
      }
    },
    eventChange(e) {
      console.dir(e.target);
      // debugger
      // if (e.target.className.includes('router-link-exact-active')) {
      e.target.classList.add("bgImage");
      // }
    },
  },
  created() {},
  mounted() {
    this.currentTime();
    this.whichday = this.myFriday(new Date().getDay());
  },
};
</script>
<style lang="less" >
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  // scrollbar-width: thin; // 宽度：auto（默认），thin（窄），none（隐藏）
  // scrollbar-color: #277a5c #3e4d51; // 颜色：第一个颜色是滑块颜色，第二个颜色是轨道颜色
}

body {
  margin: 0;
}
a {
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #f2f3f5;
  border-right: 0.0625rem solid #0c2641;
}
.bgImage {
  // height: 100%;
  // width: 20%;
  // height: 90%;
  aspect-ratio: 172.8/40;
  background: url("@/assets/activebutton.png") no-repeat center;
  background-position: center;
  background-size: contain;
}
/* .head {
  width: 80%;
  height: 5%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #fff;
  background: #000f1a;
  background: ;
} */
.header {
  width: 100%;
  // height: 5vh;
  position: relative;
  height: 8.1566%;
  // overflow: hidden;
  background: url("@/assets/NAV.png") no-repeat;
  background-position: center;
  background-size: cover;
  .navgate {
    width: 54%;
    height: 80%;
    position: absolute;
    left: 29%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      // min-width: 160px;
      max-width: 16%;
      // min-width: 10.8rem;
      aspect-ratio: 172.8/40;
      // height: 2.5rem;
      margin-top: 2%;
      height: 100%;
      background: url("@/assets/defaultbutton.png") no-repeat;
      background-position: center;
      background-size: contain;

      a {
        aspect-ratio: 172.8/40;
        font-size: 1.25rem;
        width: 100%;
        border-right: none;
        font-weight: 600;
        color: rgba(194, 211, 211, 0.76);
        font-style: italic;
        // line-height: 2.0625rem;
      }
      white-space: nowrap;
    }
  }
  .title {
    position: absolute;
    font-size: 2rem;
    left: 5%;
    top: 20%;
    font-weight: bold;
    color: #8ac5a5;
    a {
      color: #8ac5a5;
    }
    // background: pink;
    border-radius: 0rem 0rem 0rem 0rem;
    opacity: 1;
  }
  .righttopic {
    float: right;
    // background: pink;
    width: 8%;
    height: 100%;
    color: #fff;
    padding-top: 0.5%;
    .times {
      font-size: 1.8rem;
    }
    .other {
      font-size: 0.8em;
      // font-size: .8rem;
    }
  }
}
.content::-webkit-scrollbar {
  display: none;
}
body {
  background: #03252a;
}
.content {
  width: 100vw;
  height: 92.42vh;
  // overflow: hidden;
  background: #000a01;
}
@media screen and (min-width: 187.5rem) {
  html {
    font-size: 2em;
  }
  .bgImage {
    background: url("@/assets/activeButton@2x.png") no-repeat center;
    background-size: contain;
  }
  .header {
    background: url("@/assets/NAV@2x.png") no-repeat;
    .title {
      left: 8%;
      font-size: 1.5em;
    }
    .navgate {
      // padding-top: 1%;
      & > div {
        width: 22.5rem;
        height: 5.25rem;
        background: url("@/assets/defaultbutton@2x.png") no-repeat;
        background-size: cover;
        a {
          height: 100%;
          font-size: 1.5em;
        }
      }
    }
  }
}
</style>